import { logoutURL } from '@src/global/logoutURL';
import { removeJwt } from '@src/utils/jwtHelpers';

export const logOut = (returnTo) => {
    // dosnt return to salesforce page to avoid cache issues
    const retUrl = returnTo.includes('/ask-foremost') ? logoutURL(null) : logoutURL(returnTo);
    removeJwt();
    window.localStorage.removeItem('innerpage_banner_closed');
    window.location.replace(retUrl);
};
